<template>
  <div class="moderation-section">
    <!-- Moderation Status Display -->
    <div v-if="content.isDraft && content.moderationStatus === 0 && canModerate" class="justify-content-between mt-2">
      <b-card class="border bg-light">
        <h5 class="mb-2">
          {{ $t('backoffice.moderation.title') }}
        </h5>
        
        <!-- Moderation Feedback -->
        <div v-if="content.moderationFeedback" class="mb-2">
          <div class="d-flex align-items-center mb-1">
            <feather-icon
              :icon="content.moderationFeedback.isAcceptable ? 'CheckCircleIcon' : 'AlertCircleIcon'"
              :class="content.moderationFeedback.isAcceptable ? 'text-success' : 'text-danger'"
              size="18"
              class="mr-1"
            />
            <span :class="content.moderationFeedback.isAcceptable ? 'text-success' : 'text-danger'">
              {{ content.moderationFeedback.isAcceptable ? $t('backoffice.moderation.acceptable') : $t('backoffice.moderation.not-acceptable') }}
            </span>
          </div>

          <!-- Reasons -->
          <div v-if="content.moderationFeedback.reasons && content.moderationFeedback.reasons.length > 0">
            <strong class="d-block mb-1">{{ $t('backoffice.moderation.reasons') }}:</strong>
            <ul class="pl-3 mb-0">
              <li v-for="(reason, index) in content.moderationFeedback.reasons" :key="index">
                {{ reason }}
              </li>
            </ul>
          </div>
        </div>
        <div v-else>
          <p>
            {{ $t('backoffice.moderation.no-feedback') }}
          </p>
        </div>

        <!-- Moderation Actions -->
        <div class="d-flex justify-content-end mt-2">
          <b-button
            variant="outline-danger"
            class="mr-1"
            @click.stop="startModeration('reject')"
          >
            {{ $t('backoffice.moderation.reject') }}
          </b-button>
          <b-button
            variant="success"
            @click.stop="startModeration('accept')"
          >
            {{ $t('backoffice.moderation.accept') }}
          </b-button>
        </div>
      </b-card>
    </div>

    <!-- Content approved -->
    <div v-if="content.moderationStatus === 1">
      <div class="d-flex align-items-center">
        <feather-icon
          icon="CheckCircleIcon"
          size="16"
          class="text-success mr-1"
        />
        <small class="text-muted">
          {{ $t('backoffice.moderation.verified-contribution') }}
        </small>
      </div>
    </div>
    
    <!-- Content rejected -->
    <div v-if="content.moderationStatus === 2">
      <div class="d-flex align-items-center">
        <feather-icon
          icon="AlertCircleIcon"
          size="16"
          class="text-danger mr-1"
        />
        <small class="text-muted">
          {{ $t('backoffice.moderation.not-verified-contribution') }}
        </small>
      </div>
    </div>

    <!-- Moderation Feedback Modal -->
    <ModerationModal
      v-if="canModerate"
      v-model="isModerationFeedbackModalVisible"
      :moderation-action="moderationAction"
      :content="content"
      :item-type="itemType"
      :morph-type="morphType"
      :item-type-name="itemTypeName"
      :parent-key="parentKey"
      @modal-hidden="handleModalHidden"
      @moderation-complete="handleModerationComplete"
    />
  </div>
</template>

<script>
import ToastNotificationsMixin from '@core/mixins/toast-notifications/ToastNotificationsMixin';
import ModerationModal from './ModerationModal.vue';

export default {
  name: 'ModerationSection',
  
  components: {
    ModerationModal
  },
  
  mixins: [ToastNotificationsMixin],

  props: {
    content: {
      type: Object,
      required: true,
    },
    morphType: {
      type: String,
      required: true
    },
    itemType: {
      type: String,
      required: true
    },
    itemTypeName: {
      type: String,
      required: true
    },
    parentKey: {
      type: String,
      required: true
    },
    moderatorOptions: {
      type: Array,
      default: () => []
    },
    onAssignModerator: {
      type: Function,
      default: null
    },
    canModerate: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      isModerationFeedbackModalVisible: false,
      moderationAction: null
    };
  },


  methods: {
    startModeration(action) {
      this.moderationAction = action;
      this.isModerationFeedbackModalVisible = true;
    },

    handleModalHidden() {
      this.isModerationFeedbackModalVisible = false;
      this.moderationAction = null;
    },

    handleModerationComplete(eventData) {
      // Emit event to parent for handling success
      this.$emit('moderation-complete', eventData);
      
      // Close modal and reset state
      this.isModerationFeedbackModalVisible = false;
      this.moderationAction = null;
    },
    handleAssignModerator(moderatorKey) {
      if (this.onAssignModerator) {
        this.onAssignModerator(this.content, moderatorKey);
      }
    }
  }
};
</script> 